import { Reducer } from 'react';
import { Actions } from '../../actions/auth';
import { Action, AuthState } from '../../types';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';

const newConnection = new HubConnectionBuilder()
    .withUrl(import.meta.env.VITE_NOTIFICATION_HUB_URL + 'hub', {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .build();

const initialAuthState: AuthState = {
    user: null,
    isUserLoading: true,
    signalrConnection: newConnection,
};

const setUserLoading = (payload: boolean, state: AuthState): AuthState => {
    return {
        ...state,
        isUserLoading: payload,
    };
};

const setUser = (payload: AuthState): AuthState => {
    return {
        user: payload.user,
        isUserLoading: payload.isUserLoading,
        signalrConnection: payload.signalrConnection,
    };
};

const removeUser = (): AuthState => {
    return {
        user: null,
        isUserLoading: false,
    };
};

const authReducer: Reducer<AuthState, Action> = (state, action): AuthState => {
    let newState = { ...state };

    switch (action.type) {
        case Actions.USER_LOADING:
            
            newState = setUserLoading(action.payload, state);
            break;
        case Actions.USER_LOADED:
            newState = setUser(action.payload);
            break;
        case Actions.USER_UNLOADED:
            newState = removeUser();
            break;
        case Actions.USER_SIGNED_OUT:
            newState = removeUser();
            break;
        case Actions.ACCESS_TOKEN_EXPIRED:
            newState = removeUser();
            break;
        case Actions.SILENT_RENEW_ERROR:
            // Silent Renew Errors occur when the tab is not focused.
            // We should keep the user around in this case, but we
            // could add logic to show an activity modal. - (12/2/19) BS
            // newState = removeUser();
            break;
    }

    return newState;
};

export { initialAuthState, authReducer };
